import React, { lazy, Suspense, useEffect } from 'react';

import { SEARCHER_STATE } from '../../store/constants/searcher';
import SearchResults from '../../containers/SearchResults';
import HotelRatesResults from '../HotelRatesResults';
import SearcherSkeleton from '../../containers/Searcher/SearcherSkeleton';
import SearcherFilteredEmpty from '../../containers/Searcher/SearcherFilteredEmpty';

const AboutRoomPopup = lazy(
  () =>
    import(
      /* webpackChunkName: "AboutRoomPopup" */ 'src/routes/Hotel/containers/AboutRoomPopup'
    ),
);

const SearcherEmpty = lazy(
  () =>
    import(
      /* webpackChunkName: "SearcherEmptyHotel" */ 'src/routes/Hotel/components/SearcherEmpty'
    ),
);

interface SearcherResultsPropsType {
  state: (typeof SEARCHER_STATE)[keyof typeof SEARCHER_STATE];
  hasOffers: boolean;
  hasOffersForCurrentDate: boolean;
  hasOffersForCurrentDateWithFilters: boolean;
  isHotelOnly: boolean;
  emptyResultLoad: () => void;
}

export const SearcherResults = ({
  state,
  hasOffers,
  hasOffersForCurrentDate,
  hasOffersForCurrentDateWithFilters,
  isHotelOnly,
  emptyResultLoad,
}: SearcherResultsPropsType) => {
  const isCompleted = state === SEARCHER_STATE.COMPLETED;
  const isFetching = state === SEARCHER_STATE.FETCHING;
  const showSkeleton =
    (state === SEARCHER_STATE.INITIAL || isFetching) && !hasOffers;
  const showResults =
    (isCompleted || isFetching) && hasOffersForCurrentDateWithFilters;
  const showFiltered =
    hasOffersForCurrentDate && !hasOffersForCurrentDateWithFilters;
  const showEmpty = !hasOffersForCurrentDate && isCompleted;

  useEffect(() => {
    if (showEmpty) {
      emptyResultLoad();
    }
  }, [emptyResultLoad, showEmpty]);

  return (
    <div>
      {showSkeleton && <SearcherSkeleton />}
      {showResults && !isHotelOnly && (
        <SearchResults>
          <Suspense fallback={null}>
            <AboutRoomPopup />
          </Suspense>
        </SearchResults>
      )}
      {showResults && isHotelOnly && <HotelRatesResults />}
      {showFiltered && <SearcherFilteredEmpty />}
      {showEmpty && (
        <Suspense fallback={null}>
          <SearcherEmpty />
        </Suspense>
      )}
    </div>
  );
};
